<template>
  <div>

  </div>
</template>
<script>
 import {UserService} from '@/services/user.service'
 import swal from 'sweetalert2';
 import 'sweetalert2/dist/sweetalert2.css';
  import ApiService from '@/services/api.service';
  
 
  export default {
    data() {
      return {
        model: {
         
        }
      };
    },
    methods: {
     
    },
    mounted() {
    		 swal.showLoading();
			let uri = this.$base_url+'/api/v1/c/onboarding/check_status';
			 ApiService.get(uri).then(response => {
			 	swal.close();
				
				//if(response.data.type==5015){
					if(response.data.status=="detailed"){
						this.$router.push( '/incorporation');
					}
					else if(response.data.status=="select"){
						this.$router.push( '/onboarding-incorp-form');
					}
				/*}
				else if(response.data.type==5016){ 
					if(response.data.status=="detailed"){
						this.$router.push( '/onboarding-appoint-form-details');
					}
					else if(response.data.status=="select"){
						this.$router.push( '/onboarding-appoint-form');
					}
				
				}//end if-else
				else{
					this.$router.push( '/onboarding');
				}*/
				
			}) 
      	
      	
    }
  };
</script>
